import { UserIcon } from '../icons/icons'

const SIZE_CLASS = {
  sm: 'h-6 w-6 text-[11px]',
  md: 'h-9 w-9 text-sm',
  lg: 'h-24 w-24 text-3xl',
}
const ICON_SIZE = { sm: 14, md: 18, lg: 40 }

/** Decorative account photo or initials, with one shape and palette at every size. */
export function UserAvatar({
  imageUrl,
  initials,
  size = 'md',
}: {
  imageUrl?: string | null
  initials?: string | null
  size?: keyof typeof SIZE_CLASS
}) {
  return (
    <span
      aria-hidden="true"
      className={`inline-flex shrink-0 items-center justify-center overflow-hidden rounded-[20%] border border-strong bg-[image:var(--avatar-placeholder-bg)] font-semibold leading-none text-[color:var(--avatar-placeholder-text)] ${SIZE_CLASS[size]}`}
    >
      {imageUrl ? (
        <img src={imageUrl} alt="" className="h-full w-full object-cover" />
      ) : (
        <span className="transition-opacity group-hover/avatar:opacity-0 group-focus-visible/avatar:opacity-0">
          {initials ?? <UserIcon size={ICON_SIZE[size]} />}
        </span>
      )}
    </span>
  )
}
